module.exports = __webpack_public_path__ + "media/images/white-plus-b65cf3a4.png";